import { BrandliveEvent, Session, SessionPreview } from '../types/working-model';

export function formatTime(date: number | Date): string {
	return new Date(date).toLocaleString(navigator.language, { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' });
}

export function getStartTime(event: BrandliveEvent, formatted: boolean): string | null | number {
	if (event) {
		let startTime = 0;
		const sessions: Session[] | SessionPreview[] = (event.sessions ? event.sessions : event.sessionsPreviews as Session[] | SessionPreview[]);
		const len = sessions!.length;

		for (let i = 0; i < len; i++) {
			if (startTime === 0 && sessions[i].timestamp !== null)
				startTime = sessions[i].timestamp!;
			else if (startTime > sessions[i].timestamp! && sessions[i].timestamp !== null)
				startTime = sessions[i].timestamp!;
		}

		if ((startTime === null) || (startTime === 0))
			return null;
		else {
			if (formatted) {
				//return start time as formatted string
				return formatTime(startTime);
			} else {
				// return starting time as unformated number
				return startTime;
			}
		}
	}

	return null;
}